(function ($) {
	const $tabs = $('.tabs');

	if (!$tabs.length) {
		return;
	}

	$tabs.each(function () {
		const $tab = $(this);
		const $tabItems = $tab.find('.tabs__link');
		const $tabContent = $tab.find('.tabs__panel');

		$tabItems.on('click', function (e) {
			e.preventDefault();

			const $this = $(this);
			const contentId = $this.attr('href');
			const $tabPanel = $tab.find(contentId);

			$tabItems.attr('aria-selected', 'false');
			$this.attr('aria-selected', 'true');

			$tabContent.attr('aria-hidden', 'true');
			$tabPanel.attr('aria-hidden', 'false');
		});
	});

	$('.js-fullscreen').on('click', function (e) {
		e.preventDefault();

		// go into fullscreen view api
		const $this = $(this);
		const $target = $($this.attr('data-target'));

		if ($target.length) {
			// make sure the $target has overflow auto
			if ($target.hasClass('fullscreen-view')) {
				$target.removeClass('fullscreen-view');
				bodyScrollLock.enableBodyScroll($target[0]);
			} else {
				$target.addClass('fullscreen-view');
				bodyScrollLock.disableBodyScroll($target[0]);
			}
		}
	});
})(jQuery);
